import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=19fcf66c&scoped=true"
import script from "./Organisation.vue?vue&type=script&lang=js"
export * from "./Organisation.vue?vue&type=script&lang=js"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=19fcf66c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fcf66c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19fcf66c')) {
      api.createRecord('19fcf66c', component.options)
    } else {
      api.reload('19fcf66c', component.options)
    }
    module.hot.accept("./Organisation.vue?vue&type=template&id=19fcf66c&scoped=true", function () {
      api.rerender('19fcf66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/Organisation.vue"
export default component.exports